/** Узел выделения принадлежит контейнеру сообщения (включая текстовые узлы). */
function selectionNodeWithinContainer(container: Element, node: Node | null): boolean {
  if (!node) return false;
  const el =
    node.nodeType === Node.TEXT_NODE ? (node.parentElement as Element | null) : (node as Element);
  return el != null && container.contains(el);
}

/** Plain text выделения, если оба конца внутри `container`; иначе пустая строка. */
export function getSelectedPlainTextWithinContainer(container: Element): string {
  if (typeof window === 'undefined') return '';
  const sel = window.getSelection();
  if (!sel || sel.isCollapsed) return '';
  if (
    !selectionNodeWithinContainer(container, sel.anchorNode) ||
    !selectionNodeWithinContainer(container, sel.focusNode)
  ) {
    return '';
  }
  return sel.toString().trim();
}

export function getMessageCopyMenuLabel(hasSelection: boolean): string {
  return hasSelection ? 'Копировать выделенный текст' : 'Копировать текст';
}

/** Текст для копирования: выделение приоритетнее полного текста сообщения. */
export function resolveMessageCopyText(selectedText: string, messageText: string): string {
  const selected = selectedText.trim();
  if (selected.length > 0) return selected;
  return messageText.trim();
}

export { captureDocumentSelection, scheduleRestoreDocumentSelection } from '@/lib/documentSelectionPreserve';
